import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import "./create-appointment.scss";
import AppointmentCreateForm from "./appointment-create-form";
import PatientSearch from "../common/patient-search/patient-serach-appontment-create";

const CreateAppointment = ({ refresh, setShow }) => {
  const [isNewUser, setIsNewUser] = useState(true);
  const [singlePatientInfo, setSinglePatientInfo] = useState({});
  return (
    <div className="create-appointment-modal">
      <header className="create-appointment-modal__header">
        <div className="create-appointment-modal__header-text">
          <h2 className="create-appointment-modal__title">New appointment</h2>
          <p className="create-appointment-modal__subtitle">
            Find an existing patient or register a new one, then complete the
            details.
          </p>
        </div>
        {typeof setShow === "function" && (
          <button
            type="button"
            className="create-appointment-modal__close"
            onClick={() => setShow(false)}
            aria-label="Close"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        )}
      </header>
      <div className="create-appointment-modal__body">
        <aside className="create-appointment-modal__search">
          <PatientSearch
            setIsNewUser={setIsNewUser}
            setSinglePatientInfo={setSinglePatientInfo}
            singlePatientInfo={singlePatientInfo}
            isNewUser={isNewUser}
            buttonName="New Appointment"
            useFlexHeight
            className="patient-search-section-appointment--modal"
          />
        </aside>
        <section className="create-appointment-modal__form">
          <AppointmentCreateForm
            setShow={setShow}
            refresh={refresh}
            isNewUser={isNewUser}
            setIsNewUser={setIsNewUser}
            selectedPatientInfo={singlePatientInfo}
            setSinglePatientInfo={setSinglePatientInfo}
          />
        </section>
      </div>
    </div>
  );
};

export default CreateAppointment;
